import { CommApiInstance } from "Utils/CommApiInstance";


const TcktLstApi = async (
) => {
    return await CommApiInstance.post(`memb/tckt/lst`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default TcktLstApi;